import { useMutation } from 'react-query'
import { useDealership } from '../../../store/zustand/dealershipStore'
import request from '../../request'

export const useEditLinkCampaign = () => {
  const dealership = useDealership()

  return useMutation(
    ({ data, link_campaign_id }: { data: any; link_campaign_id: number }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/${link_campaign_id}`,
        method: 'PATCH',
        data,
      }),
  )
}
